import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';

import { DefaultFilter } from '../../core/framework/default-service.interface';
import { DefaultServiceInterface } from 'src/app/core/framework/default-service.interface';
import { DefaultService } from 'src/app/core/framework/default-service';
import { PermissaoPorPerfilDTO } from './permissao/permissao-por-perfil-dto.model';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Permissao } from './permissao/permissao.model';
import { IMosaicoModulo } from './mosaico-de-permissao/model/mosaico-de-permissao.interface';
import { PerfilDeAcesso, PerfilDeAcessoFilter } from './model/perfil-de-acesso.model';

@Injectable({
  providedIn: 'root'
})
export class PerfilDeAcessoService extends DefaultService<any> {

  static URL = '/api/seguranca/v1/perfis';

  constructor(
      public httpClient: HttpClient
      , public errorHandler: ErrorHandlerService
  ) {
      super(
        httpClient,
        errorHandler,
        PerfilDeAcessoService.URL
      );
  }

  listarPermissoes(idPerfil: number, filter: DefaultFilter): Observable<Permissao[]> {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam(filter);
    return this.httpClient.get<Permissao[]>(`${PerfilDeAcessoService.URL}/${idPerfil}/permissoes`, {params})
                .pipe(
                  catchError((err: any) => throwError(this.errorHandler.handle(err)))
                );
  }

  listarPermissoesPorPerfil(idPerfil: number, filter: DefaultFilter): Observable<PermissaoPorPerfilDTO[]> {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam(filter);
    return this.httpClient.get<PermissaoPorPerfilDTO[]>(`${PerfilDeAcessoService.URL}/${idPerfil}/permissoesPorPerfil`, {params})
                .pipe(
                  catchError((err: any) => throwError(this.errorHandler.handle(err)))
                );
  }

  listarPermissoesPorPerfilMosaico(idPerfil: number, filter: DefaultFilter): Observable<IMosaicoModulo[]> {
    const params = DefaultServiceInterface.converterFiltroParaHttpParam(filter);
    return this.httpClient.get<String>(`${PerfilDeAcessoService.URL}/${idPerfil}/permissoesPorPerfilEmMosaico`, {params})
                .pipe(
                  map( (response: any) => {
                    const modulos: IMosaicoModulo[] = [];
                    for ( const modulo of response ) {
                      modulos.push(modulo);
                    }

                    return modulos;
                  })
                  , catchError((err: any) => throwError(this.errorHandler.handle(err)))
                );
  }

  inserirPermissao(idPerfil, idPermissao): Observable<any> {
      return this.httpClient.post(`${PerfilDeAcessoService.URL}/${idPerfil}/permissoes`, idPermissao, this.httpOptions)
                            .pipe(
                              catchError((err: any) => throwError(this.errorHandler.handle(err)))
                            );
  }

  excluirPermissao(idPerfil: number, idPermissao: number): Observable<void> {
      return this.httpClient.delete<void>(`${PerfilDeAcessoService.URL}/${idPerfil}/permissoes/${idPermissao}`, this.httpOptions)
                            .pipe(
                              catchError((err: any) => throwError(this.errorHandler.handle(err)))
                            );
  }

  unificarPerfil(idPerfilOrigem: number, idPerfilDestino: number): Observable<PerfilDeAcesso> {
    return this.httpClient.put<PerfilDeAcesso>(`${PerfilDeAcessoService.URL}/unificar/${idPerfilOrigem}/para/${idPerfilDestino}`, this.httpOptions)
                          .pipe(
                            catchError((err: any) => throwError(this.errorHandler.handle(err)))
                          );
  }

  criarComPerfilDeBase(perfilDeAcesso: PerfilDeAcessoFilter, idPerfilDeBase: number): Observable<PerfilDeAcesso> {
    return this.httpClient.post<PerfilDeAcesso>(`${PerfilDeAcessoService.URL}/criarComPerfilDeBase/${idPerfilDeBase}`, perfilDeAcesso, this.httpOptions)
                          .pipe(
                            catchError((err: any) => throwError(this.errorHandler.handle(err)))
                          );
  }  

}
